module.exports = __webpack_public_path__ + "img/tate-parking.0c9b9587.jpg";